import {ValidationError} from '../../models/validation-error.model';
import {RepositoryPolicyCancel} from '../../models/repository-policy.model';
import {OceanPolicyChanges, OceanPolicyFile} from '../../models/simplified-ocean-policy.model';

export namespace RepositoryPoliciesAsideActions {
    export class StartDataChange {
        static readonly type = 'RepositoryPoliciesAsideActions.StartDataChange';
    }

    export class DataChange {
        static readonly type = 'RepositoryPoliciesAsideActions.DataChange';

        constructor(public policyId: string, public data: OceanPolicyChanges) {
        }
    }

    export class StartTermination {
        static readonly type = 'RepositoryPoliciesAsideActions.StartTermination';
    }

    export class Termination {
        static readonly type = 'RepositoryPoliciesAsideActions.Termination';

        constructor(public policyId: string, public data: RepositoryPolicyCancel) {
        }
    }

    export class GetTerminationReasons {
        static readonly type = 'RepositoryPoliciesAsideActions.GetTerminationReasons';

        constructor(public policyId: string) {
        }
    }

    export class GetPaybackAmount {
        static readonly type = 'RepositoryPoliciesAsideActions.GetPaybackAmount';

        constructor(public policyId: string, public data: RepositoryPolicyCancel) {
        }
    }

    export class GetDocuments {
        static readonly type = 'RepositoryPoliciesAsideActions.GetDocuments';

        constructor(public policyId: string) {
        }
    }

    export class UpdateDocuments {
        static readonly type = 'RepositoryPoliciesAsideActions.UpdateDocuments';

        constructor(public policyId: string) {
        }
    }

    export class DownloadDocument {
        static readonly type = 'RepositoryPoliciesAsideActions.DownloadDocument';

        constructor(public policyId: string, public hash: string, public fileName: string) {
        }
    }

    export class AddDocument {
        static readonly type = 'RepositoryPoliciesAsideActions.Add';

        constructor(public policyId: string, public readonly file: OceanPolicyFile) {
        }
    }

    export class FormFailure {
        static readonly type = 'RepositoryPoliciesAsideActions.FormFailure';

        constructor(public readonly validationErrors: ValidationError[]) {
        }
    }

    export class NoDataChange {
        static readonly type = 'DataPointPoliciesAsideActions.NoDataChange';
    }

    export class ClearValidationErrors {
        static readonly type = 'DataPointPoliciesAsideActions.ClearValidationErrors';
    }
}
